import {bindable, computedFrom, customElement, inject} from "aurelia-framework";
import {DateValueConverter} from "../../converters";
import {I18N} from "aurelia-i18n";

@customElement("sio-tourism-booking-state-display")
@inject(DateValueConverter, I18N)
export class BookingStateDisplay {
    @bindable state;
    @bindable rawState;
    @bindable stateBefore;
    @bindable item;

    constructor(dateConverter, i18n) {
        this.dateConverter = dateConverter;
        this.i18n = i18n;
    }

    @computedFrom("state", "stateBefore", "item")
    get title() {
        const title = [];

        if (this.stateBefore) {
            title.push(this.i18n.tr("order.detail.bookingStatus." + this.stateBefore) + " →");
        }

        title.push(this.i18n.tr("order.detail.bookingStatus." + (this.rawState ?? this.state)));

        let info = '';

        if (this.item) {
            info = this.item?.order?.bookingStatusReason;

            if ("option" === this.state || 'optionRequest' === this.state || 'confirmedOption' === this.state) {
                if (this.item?.order?.optionDate) {
                    info = this.i18n.tr("order.detail.until") + " " + this.dateConverter.toView(this.item?.order?.optionDate, 'L');
                }

                if (this.item?.order?.optionRealizationBehavior) {
                    info += ", " + this.i18n.tr("setting.order.option_realization_behavior." + this.item.order.optionRealizationBehavior);
                }
            }

            if ("bookingOnExecution" === this.state && this.item.bookingExecutionType) {
                info = this.i18n.tr("order.execution." + this.item.bookingExecutionType);
            }

            if (this.item.lastStateChange) {
                info = this.i18n.tr("order.detail.lastStateChange") + ' ' + this.dateConverter.toView(this.item.lastStateChange, 'L LT');
            }

            if ((info ?? "").length) {
                title.push("(" + info + ")");
            }
        }

        return title.join(" ");
    }
}
